import {
  UseZoomCommandChannelMessageListenerOptions,
  useZoomCommandChannelMessageListener,
} from './useZoomCommandChannelMessageListener';

export function ZoomCommandChannelMessageListener({ onMessageReceived }: UseZoomCommandChannelMessageListenerOptions) {
  useZoomCommandChannelMessageListener({ onMessageReceived });

  return null;
}
